function RevealMetadataCollection( element )
{
  	//get all of the parents
    var container = document.querySelector( ".footer-row-mob" );
  	var parents   = container.querySelectorAll( ".bridgman-footer-menu-container" );
  
   	//show the container clicked
  	var elParent 				= element.parentNode;
  	var elParentMenu			= elParent.querySelector( ".bridgman-footer-menu-ul" );
  	var elParentMenuContainer	= elParent.querySelector( ".bridgman-footer-menu-container" );
  	var elementMenuContainerShowing;
  
  	if( elParentMenuContainer.offsetHeight > 0 )
    {
     	//must be showing
        elementMenuContainerShowing = true;
    }
  	else
    {
      	//must not be showing
	    elementMenuContainerShowing = false;
    }
  	
  
  	//loop through all of the parents
  	for( var i = 0; i < parents.length; i++ )
    {
      	var parent = parents[ i ];
      
      	//hide all of the containers
		parent.setAttribute( "style", "overflow: hidden; height: 0px;" );
		// parent.style.transition = "height 1s ease";
    }
  	
  	//if it's not showing at the point of clicking then show
  	if( !elementMenuContainerShowing )
    {
		elParentMenuContainer.setAttribute( "style", "height:" + parseInt(elParentMenu.offsetHeight + 30) + "px" );
		// elParentMenuContainer.style.transition = "height 1s ease";    
    }
}